import {FlexBox, useToasts, useIsMobile, useBreakpoint, BrgButton, ButtonVariant} from '@brg/ui';
import { MobileFilterSort } from 'shared/pages/explore/styles';
import { SortIcon } from 'shared/icons';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { API, Endpoints, Nullable, PageModel, Project, GetProjectsByFilterProps, TeamAPI } from '@brg/api';
import {LayoutConst, useModal} from '../../../core';
import { TeamTabProjectsOrderGrid } from '../teamTabProjectsOrder/TeamTabProjectsOrderGrid';
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import {
  ActionsTitle,
  ActionsWrapper,
  MainTitle,
  ActionBottomButtons,
  ModalContainer,
  NoProjectWrapper, ProjectTabItem,
  SecondTitle
} from './styles';
import { ProjectsSearchBar } from 'shared/components/projectsSearchBar/projectsSearchBar';
import { SortingTypeIndex } from 'shared/constants/sortingType';
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { AppTester } from 'supporting';
import { ProjectsGridNew } from 'shared/components/grids';
import ProjectCardNew from 'shared/components/projectCard/projectCardNew';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import { ProjectDelegate } from 'project-delegate';
import { RingPositions } from 'shared/constants/ringPositionType';
import {useProjectsList} from "../../hooks/api/useProjectsByFilter";
import {DropdownTabs} from "../../pages/exploreHseContextsNew/components/DropdownTabs";
import {useTranslation} from "react-i18next";
import {useProfile} from "@brg/auth";
import {SearchInputComponent} from "../../components/SearchInput/SearchInputComponent";
import {Pagination} from "../../components/pagination";
import { useParams, useRouteMatch } from 'react-router-dom';
import { LinkTo } from 'shared/constants/linkTo';
import { useDebounceCallback } from 'shared/helpers/useDebounceCallback';

enum SEND_PROJECT_TABS {
  projects = 'projects',
  presentations = 'presentations',
  books = 'books',
  bookmarks = 'bookmarks',
  find_projects = 'find_projects',
  selected_projects = 'selected_projects'
}

const MIN_PROJECT_SEARCH_LENGTH = 2

const appendArrayQuery = (
  req: ReturnType<typeof API.request>,
  key: string,
  values?: (string | number)[] | null,
) => {
  if (!values?.length) {
    return
  }

  values.forEach((value) => req.addQuery(key, value))
}

interface ISendProjectProps {
  alreadyProjects?: string[],
  project: Project,
  onSelectProjects?: (val: string[]) => void,
  maxProjects?: number,
  teamExtraFilter?: any,
  teamContexts?: string[],
  isPresentation?: boolean,
  hideBookmark?: boolean;
  status?: number,
  hideSearch?: boolean;
  contextsNotContains?: string[];
  onlyOnePresentation?: boolean;
  submitText?: string;
  descriptionText?: string;
  externalParams?: Record<string, any>;
  onlyAuthorProjects?: boolean;
  allowSelectedProjectsReorder?: boolean;
}

export const SendProjectLongreadModal: FC<ISendProjectProps> = (props) => {

  const {
    alreadyProjects: alreadyProjectIds,
    onSelectProjects,
    maxProjects = 1,
    teamExtraFilter,
    status = undefined,
    teamContexts,
    onlyOnePresentation = true,
    onlyAuthorProjects,
    contextsNotContains,
    hideBookmark,
    hideSearch,
    externalParams,
    submitText,
    descriptionText,
    project,
    allowSelectedProjectsReorder = false,
  } = props;

  const profile = useProfile()
  const [alreadyTime, setAlreadyTime] = useState(new Date().getTime())
  const [time, setT] = useState(new Date().getTime())
  const { t, i18n: { language } } = useTranslation();
  const isGeo = AppTester.isGeograffee();
  const isLMS = AppTester.isLMSHSE();
  const publishedStatuses = useMemo(() => (isLMS ? [1, 10] : [1]), [isLMS]);
  const [sorting, setSorting] = useState(1)
  const [searchText, setSearchText] = useState('')
  const [searchInputValue, setSearchInputValue] = useState('')
  const debouncedSetSearchText = useDebounceCallback(setSearchText, 350)
  const [activeTab, setActiveTab] = useState<string | SEND_PROJECT_TABS>(SEND_PROJECT_TABS.projects)
  const toasts = useToasts();
  const isMobile = useIsMobile()
  const isS = useBreakpoint(LayoutConst.screen.s - 1)
  const modal = useModal();
  const isProjectEdit = useRouteMatch(LinkTo.projectEdit)?.params as Record<string, string>
  const [filterOpt, setFilterOpt] = useState<GetProjectsByFilterProps | null>(
      null
  )
  const [selectedProjects, setSelectedProjects] = useState<{id: string, isPresentation: boolean}[]>([])
  const [projectsCache, setProjectsCache] = useState<Record<string, Project>>({})
  const [searchProjectsPage, setSearchProjectsPage] = useState<PageModel<Project> | null>(null)
  const [isSearchProjectsLoading, setIsSearchProjectsLoading] = useState(false)
  const [searchAuthorIds, setSearchAuthorIds] = useState<string[] | null>(null)

  const mergeProjectsIntoCache = useCallback((items?: Project[]) => {
    if (!items?.length) {
      return
    }

    setProjectsCache((prev) => {
      const next = { ...prev }
      let changed = false

      items.forEach((item) => {
        const projectId = item?.projectId
        if (!projectId) {
          return
        }

        if (next[projectId]) {
          return
        }

        next[projectId] = item
        changed = true
      })

      return changed ? next : prev
    })
  }, [])

  const currentProjectId = useMemo(() => (isProjectEdit?.id || undefined), [isProjectEdit]);

  const isEditing = (id: string) => {
    return id === currentProjectId
  }

  const [currentPage, setPage] = useState(1)
  const onPageChange = useCallback((page: any): void => {
    setPage(page)
    setFilterOpt(null)
    setT(Date.now())
  }, [])
  const onSend = useCallback(() => {
    const data = selectedProjects?.map((project: any) => project?.id)
    onSelectProjects && onSelectProjects(data)
    modal.hide()
  }, [onSelectProjects, selectedProjects])
  const is1440BP = useBreakpoint(LayoutConst.screen.s)

  const scrollTop = () => window.scrollTo(0, 0);

  const searchedId = useMemo(() => {
    const splittedText = searchText?.split('/');
    const lastPart = splittedText?.length > 0 ? splittedText[splittedText?.length - 1] : '';
    
    const idMatch = lastPart.match(/([a-f0-9]{32})$/i);
    return idMatch ? idMatch[1] : lastPart;
  }, [searchText])
  const isSearchLink = useMemo(() => {
    const splittedText = searchText?.split('/');
    return splittedText?.length > 1;
  }, [searchText])

  const noSelectedProjects = useMemo(
    () => selectedProjects?.length === 0 && activeTab === SEND_PROJECT_TABS.selected_projects,
    [selectedProjects?.length, activeTab],
  )
  const trimmedSearchText = useMemo(() => searchText.trim(), [searchText])

  const isFindProjectsByLink = useMemo(
    () => activeTab === SEND_PROJECT_TABS.find_projects && isSearchLink,
    [activeTab, isSearchLink],
  )

  const isFindProjectsByName = useMemo(
    () => (
      activeTab === SEND_PROJECT_TABS.find_projects
      && !isSearchLink
      && trimmedSearchText.length >= MIN_PROJECT_SEARCH_LENGTH
    ),
    [activeTab, isSearchLink, trimmedSearchText],
  )

  const noFindProjects = useMemo(
    () => activeTab === SEND_PROJECT_TABS.find_projects && !isFindProjectsByLink && trimmedSearchText.length < MIN_PROJECT_SEARCH_LENGTH,
    [activeTab, isFindProjectsByLink, trimmedSearchText],
  )
  const teamIdForSearch = useMemo(
    () => externalParams?.authorIdsFromTeamIds?.[0] as string | undefined,
    [externalParams?.authorIdsFromTeamIds],
  )
  const hasTeamAuthorsScope = useMemo(() => !!teamIdForSearch, [teamIdForSearch])
  const hasResolvedSearchAuthors = useMemo(
    () => !hasTeamAuthorsScope || !!searchAuthorIds,
    [hasTeamAuthorsScope, searchAuthorIds],
  )
  const isSelectedProjectsReorderMode = (
    allowSelectedProjectsReorder && activeTab === SEND_PROJECT_TABS.selected_projects
  )

  const [projects, isProjectsDefaultLoading, , projectsPaging] = useProjectsList(
    filterOpt,
    language,
    time,
    filterOpt === null
    || noSelectedProjects
    || noFindProjects
    || isFindProjectsByName
  )

  const [alreadyProjects, isProjectsAlreadyLoading, , projectsAlreadyPaging] = useProjectsList(
    // @ts-ignore
    {projectIds: alreadyProjectIds || [], isContextIgnored: true, projectStatus: publishedStatuses, onlyBooks: '', ...(allowSelectedProjectsReorder ? { orderByProjectIds: true } : {})},
    language,
    alreadyTime,
    alreadyProjectIds?.length === 0
  )

  useEffect(() => {
    if (allowSelectedProjectsReorder && alreadyProjectIds?.length) {
      setActiveTab(SEND_PROJECT_TABS.selected_projects)
    }
  }, [allowSelectedProjectsReorder, alreadyProjectIds])

  useEffect(() => {
    const loadedProjects = alreadyProjects?.data || []

    if (allowSelectedProjectsReorder && alreadyProjectIds?.length) {
      const projectsById = new Map(
        loadedProjects.map((project: any) => [project?.projectId, project]),
      )

      setSelectedProjects(
        alreadyProjectIds
          .map((id) => projectsById.get(id))
          .filter(Boolean)
          .map((project: any) => ({
            id: project?.projectId,
            isPresentation: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'].includes(project?.projectType),
          })),
      )
      return
    }

    setSelectedProjects(loadedProjects.map((project: any) => ({
      id: project?.projectId,
      isPresentation: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'].includes(project?.projectType)
    })) || [])
  }, [alreadyProjects, allowSelectedProjectsReorder, alreadyProjectIds])

  useEffect(() => {
    mergeProjectsIntoCache(projects?.data as Project[] | undefined)
  }, [mergeProjectsIntoCache, projects?.data])

  useEffect(() => {
    mergeProjectsIntoCache(searchProjectsPage?.data as Project[] | undefined)
  }, [mergeProjectsIntoCache, searchProjectsPage?.data])

  useEffect(() => {
    mergeProjectsIntoCache(alreadyProjects?.data as Project[] | undefined)
  }, [alreadyProjects?.data, mergeProjectsIntoCache])

  const isProjectsLoading = useMemo(
    () => isProjectsAlreadyLoading || (isFindProjectsByName ? isSearchProjectsLoading : isProjectsDefaultLoading),
    [isFindProjectsByName, isProjectsAlreadyLoading, isProjectsDefaultLoading, isSearchProjectsLoading],
  )

  const coauthorsIds = useMemo(() => {
    if (!teamExtraFilter && project) {
      return project?.coAuthorIds
    }
    return []
  } , [project, teamExtraFilter])

  const authorsIds = useMemo(() => {
    if (!teamExtraFilter && project) {
      return [project?.authorId]
    }
    return []
  } , [project, teamExtraFilter])

  useEffect(() => {
    if (!teamIdForSearch) {
      setSearchAuthorIds(null)
      return
    }

    let isCancelled = false

    TeamAPI.Get({ idTeam: teamIdForSearch })
      .then((response) => response.json())
      .then((teamRaw: any) => {
        if (isCancelled) {
          return
        }

        const nextAuthorIds = Array.from(new Set([
          ...(teamRaw?.ownersIDs || []),
          ...(teamRaw?.membersIDs || []),
        ].filter(Boolean)))

        setSearchAuthorIds(nextAuthorIds)
      })
      .catch(() => {
        if (!isCancelled) {
          setSearchAuthorIds([])
        }
      })

    return () => {
      isCancelled = true
    }
  }, [teamIdForSearch])

  useEffect(() => {
    if (profile && profile?.accountId) {
      const hasTeamAuthorsScope = !!externalParams?.authorIdsFromTeamIds?.filter(Boolean)?.length

      const baseFilters: any = {
        projectFilter: sorting,
        page: currentPage,
        limit: 8,
        projectStatus: publishedStatuses,
        isContextIgnored: true,
        onlyBooks: '',
        ...(currentProjectId ? { excludeProjectIds: [currentProjectId]} : {}),
        contextsNotContains: ['lmsproject', 'lmshseproject', ...(contextsNotContains || [])]
      }
      let defaultFilters: any = {
        ...baseFilters,
        onlyBookmarks: activeTab === SEND_PROJECT_TABS.bookmarks,
      }

      const additionalFilter = hasTeamAuthorsScope ? {} : {
        ...(!!onlyAuthorProjects && activeTab !== SEND_PROJECT_TABS.find_projects ? { onlyAuthors: !!onlyAuthorProjects } : {}),
        ...(!!onlyAuthorProjects ? 
          //@ts-ignore
          { authorIds: [...new Set([...(coauthorsIds || []), ...(authorsIds || []) , profile?.accountId ])] } : 
          //@ts-ignore
          {authorOrCoAuthorIds:  [...new Set([...(coauthorsIds || []), ...(authorsIds || []) , profile?.accountId])]}),
      }

      const withoutTeamFilters = activeTab === SEND_PROJECT_TABS.selected_projects || activeTab === SEND_PROJECT_TABS.find_projects || activeTab === SEND_PROJECT_TABS.bookmarks;
      
      if (teamExtraFilter && !withoutTeamFilters) defaultFilters = {...defaultFilters, isContextIgnored: true, ...teamExtraFilter}
      else if ((teamContexts || [])?.length > 0 && !withoutTeamFilters) defaultFilters = {...defaultFilters, contexts: teamContexts, isContextIgnored: false, ...additionalFilter}
      else if (!withoutTeamFilters) defaultFilters = {...defaultFilters, ...additionalFilter }

      if (activeTab === SEND_PROJECT_TABS.bookmarks) defaultFilters = {...defaultFilters, page: currentPage, limit: 8, onlyBookmarks: activeTab === SEND_PROJECT_TABS.bookmarks, selectProjects: true }
      if (activeTab === SEND_PROJECT_TABS.projects) defaultFilters = {
        ...defaultFilters,
        ...additionalFilter,
        excludeProjectTypes: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'],
        onlyBooks: false,
      }
      if (activeTab === SEND_PROJECT_TABS.presentations) defaultFilters = {
        ...defaultFilters,
        ...additionalFilter,
        projectTypes: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'],
        onlyBooks: false,
      }
      if (activeTab === SEND_PROJECT_TABS.books) {
        defaultFilters = {
          ...defaultFilters,
          ...additionalFilter,
          onlyBooks: true,
          bookStatus: publishedStatuses,
          bookSort: sorting,
        }
      }

      if (activeTab === SEND_PROJECT_TABS.selected_projects) {
        defaultFilters = null
      }
      if (isFindProjectsByLink) {
        defaultFilters = {
          projectFilter: sorting,
          page: currentPage,
          limit: 8,
          isContextIgnored: true,
          projectIds: [searchedId],
          onlyBooks: '',
          ...additionalFilter,
        }
      }

      if (activeTab === SEND_PROJECT_TABS.find_projects && !isFindProjectsByLink) {
        defaultFilters = null
      }

      if (externalParams) {
        const { onlyBooks: externalOnlyBooks, ...restExternalParams } = externalParams
        defaultFilters = {
          ...defaultFilters,
          ...restExternalParams,
          ...(activeTab !== SEND_PROJECT_TABS.books
            && externalOnlyBooks != null
            && externalOnlyBooks !== ''
            ? { onlyBooks: externalOnlyBooks }
            : {}),
        }
      }

      defaultFilters = {
        ...defaultFilters,
        projectStatus: publishedStatuses,
        ...(activeTab === SEND_PROJECT_TABS.books ? { bookStatus: publishedStatuses } : {}),
      }

      setFilterOpt((defaultFilters)
      )
    }
  }, [profile, sorting, currentProjectId, contextsNotContains, currentPage, coauthorsIds, isFindProjectsByLink, onlyAuthorProjects, teamContexts, teamExtraFilter, activeTab, searchedId, publishedStatuses, externalParams])

  useEffect(() => {
    setT(Date.now())
  }, [activeTab, filterOpt])

  useEffect(() => {
    if (activeTab === SEND_PROJECT_TABS.find_projects) {
      onPageChange(1)
    }
  }, [searchText, activeTab, onPageChange])

  useEffect(() => {
    if (!isFindProjectsByName) {
      setSearchProjectsPage(null)
      setIsSearchProjectsLoading(false)
      return
    }

    if (!hasResolvedSearchAuthors) {
      setSearchProjectsPage(null)
      setIsSearchProjectsLoading(false)
      return
    }

    const controller = new AbortController()
    setIsSearchProjectsLoading(true)

    const req = API.request()
      .endpoint(Endpoints.geograffee)
      .url('/api/project/AutoCompletePaging')
      .get()
      .addQuery('key', trimmedSearchText)
      .addQuery('page', currentPage)
      .addQuery('limit', 8)
      .addQuery('projectFilter', sorting)

    appendArrayQuery(req, 'projectStatus', publishedStatuses)
    appendArrayQuery(
      req,
      'authorIds',
      hasTeamAuthorsScope ? searchAuthorIds : externalParams?.authorIds,
    )
    appendArrayQuery(req, 'authorOrCoAuthorIds', externalParams?.authorOrCoAuthorIds)
    appendArrayQuery(req, 'contextsNotContains', ['lmsproject', 'lmshseproject', ...(contextsNotContains || [])])

    req.send({ signal: controller.signal })
      .then((response) => response.json())
      .then((json) => {
        if (controller.signal.aborted) {
          return
        }

        setSearchProjectsPage(API.toLang<PageModel<Project>>(json, language))
      })
      .catch((error) => {
        if (controller.signal.aborted || error?.name === 'AbortError') {
          return
        }

        setSearchProjectsPage(null)
      })
      .finally(() => {
        if (!controller.signal.aborted) {
          setIsSearchProjectsLoading(false)
        }
      })

    return () => controller.abort()
  }, [
    isFindProjectsByName,
    trimmedSearchText,
    currentPage,
    sorting,
    language,
    publishedStatuses,
    externalParams,
    hasResolvedSearchAuthors,
    hasTeamAuthorsScope,
    searchAuthorIds,
    contextsNotContains,
  ])

  const onMobileSortingClick = useCallback(() => {
    setSorting(sorting === 1 ? 2 : 1);
    onPageChange(1)
    setT(Date.now())
  }, [sorting, setSorting]);

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s)
    onPageChange(1)
    setT(Date.now())
  }, [])
  const onSelect = useCallback((project: Project | undefined): void => {
    if (project?.projectId) {
      mergeProjectsIntoCache([project])
    }

    // @ts-ignore
    const isPresentation = ['fixed-ratio-large', 't-shape', 'fixed-ratio-small'].includes(project?.projectType);

    if ((isPresentation || selectedProjects?.findIndex(selectedProjects => selectedProjects?.isPresentation) !== -1) && onlyOnePresentation) {
      setSelectedProjects([{id: project?.projectId || '', isPresentation}])
      return;
    }

    // @ts-ignore
    setSelectedProjects((prev: {id: string, isPresentation: boolean}[]) => {

      const includes = prev?.findIndex(selectedProjects => selectedProjects?.id === project?.projectId) !== -1

      if (includes)
        return prev.filter((a) => a?.id !== project?.projectId)
      if (prev?.length > (maxProjects - 1)) {
        toasts.error(t('competition.max_error') + ' ' + maxProjects);
        return prev;
      }
      return [...prev, {id: project?.projectId, isPresentation}]
    })
  }, [mergeProjectsIntoCache, maxProjects, onlyOnePresentation, toasts, t])

  const displayProjects = useMemo(() => {
    if (activeTab === SEND_PROJECT_TABS.selected_projects || isSelectedProjectsReorderMode) {
      return selectedProjects
        .map(({ id }) => projectsCache[id])
        .filter(Boolean) as Project[]
    }

    if (isFindProjectsByName) {
      return (searchProjectsPage?.data || []) as Project[]
    }

    return (projects?.data || []) as Project[]
  }, [activeTab, isFindProjectsByName, isSelectedProjectsReorderMode, projects?.data, projectsCache, searchProjectsPage?.data, selectedProjects])

  const selectedProjectIds = useMemo(
    () => new Set(selectedProjects.map(({ id }) => id)),
    [selectedProjects],
  )

  const onToggleSelectedProject = useCallback((projectId: string) => {
    const project = projectsCache[projectId]
      || displayProjects.find(({ projectId: id }) => id === projectId)
      || projects?.data?.find(({ projectId: id }) => id === projectId)
      || searchProjectsPage?.data?.find(({ projectId: id }) => id === projectId)

    onSelect(project as Project | undefined)
  }, [displayProjects, onSelect, projects?.data, projectsCache, searchProjectsPage?.data])

  const onSelectedProjectSortEnd = useCallback((projectId: string, newIndex: number) => {
    setSelectedProjects((prev) => {
      const oldIndex = prev.findIndex(({ id }) => id === projectId)
      if (oldIndex === -1 || oldIndex === newIndex) {
        return prev
      }

      return arrayMoveImmutable(prev, oldIndex, newIndex)
    })
  }, [])

  const renderProjectCard = useCallback((v: Nullable<Partial<Project<'Local'>>>, index: number) => (
    <ProjectCardNew
      project={v as any}
      isModal={true}
      withoutGoToProject={true}
      onProjectClick={modal ?
        (projectId?: string, e?: any) => {
          e?.stopPropagation();
          e?.preventDefault();
        } : undefined}
      isSelectable={true}
      //@ts-ignore
      isRejected={ProjectDelegate.isRejectedProject(v)}
      key={(v?.projectId || '') + index}
      {...computeProject(v)}
      isSelectRightNeed={isMobile}
      editingProject={isEditing(v?.projectId ?? '')}
      metaAlwaysVisible
      selectRingPosition={RingPositions.right}
      onSelectProject={onSelect}
      //@ts-ignore
      selected={selectedProjects?.findIndex(selectedProject => selectedProject?.id === v?.projectId ?? '') !== -1}
    />
  ), [isEditing, isMobile, modal, onSelect, selectedProjects])

  const projectsGrid = useMemo(
    () => displayProjects.map((v, index) => renderProjectCard(v, index)),
    [displayProjects, renderProjectCard],
  )

  const searchBar = useMemo(
      () => (
          <ProjectsSearchBar
              isLoading={false}
              sorting={sorting}
              hideRightBar={false}
              hideLeftBar
              hideRightButtons
              onSortingChange={onSortingChange}
              isTagPage={false}
              projectCount={projects?.data?.length}
          />
      ),

      [sorting, onSortingChange, projects]
  )

  const tabNames = useMemo(() => {

    const extraTabs = {
      ...(teamExtraFilter && !hideBookmark && {[SEND_PROJECT_TABS.bookmarks]: t('send_projects.bookmarks')}),
      ...(!hideSearch && {[SEND_PROJECT_TABS.find_projects]: t('send_projects.find_projects')}),
    }

    return ({
      [SEND_PROJECT_TABS.projects]: t('send_projects.projects'),
      [SEND_PROJECT_TABS.presentations]: t('send_projects.presentations'),
      [SEND_PROJECT_TABS.books]: t('send_projects.books'),
      ...extraTabs,
      [SEND_PROJECT_TABS.selected_projects]: t('send_projects.selected_projects') + ' ' + selectedProjects?.length || 0
    })

  }, [selectedProjects, teamExtraFilter, hideBookmark, hideSearch, t])

  const MobileDropdownTabs = useMemo(() => {

    return (
        <DropdownTabs
            whiteTheme={false}
            activeTabKey={activeTab}
            items={tabNames}
            onChange={(tab: any) => {
              setActiveTab(tab)
            }}
        />
    )
  }, [activeTab, tabNames])

  const isNoProjects = useMemo(() => {
    if (activeTab === SEND_PROJECT_TABS.selected_projects) {
      return displayProjects.length === 0
    }

    if (isFindProjectsByName) {
      return !isSearchProjectsLoading && (searchProjectsPage?.data?.length === 0 || !searchProjectsPage?.data)
    }

    return (
      (!isProjectsLoading && (projects?.data?.length === 0 || !projects?.data))
      || noFindProjects
    )
  }, [
    activeTab,
    displayProjects.length,
    isFindProjectsByName,
    isProjectsLoading,
    isSearchProjectsLoading,
    noFindProjects,
    projects?.data,
    searchProjectsPage?.data,
  ])
      
  return (
    <ModalContainer style={{ overflow: 'auto', height: '100%'}} justify="flex-start" offsetTop={88} offsetTopMobile={1}>
      
        <FlexBox width={'100%'} directionMobile='column' justify={isMobile ? 'flex-start': 'center'} align={isMobile ? "center" : 'flex-start'} style={{ position: 'relative'}}>
            <ActionsWrapper direction="column" style={{ justifyContent: 'center', position: 'relative' }}>
              <ActionsTitle justify='space-between' justifyMobile='flex-start' direction='row' >
                <FlexBox direction='column'>
                    <MainTitle>
                        {t(`competition.${maxProjects > 1 ? 'select_projects' : 'select_project'}`)}
                    </MainTitle>
                    {descriptionText && (
                      <SecondTitle>{descriptionText}</SecondTitle>
                    )}
                </FlexBox>
                <ActionBottomButtons>
                  <BrgButton
                    variant={ButtonVariant.Filled} 
                    fullWidth
                    disabled={selectedProjects?.length > maxProjects} 
                    onClick={onSend}
                  >
                    {`${submitText || t('competition.send')}${selectedProjects?.length > 0 ? ` (${selectedProjects?.length})` : ''}`}
                  </BrgButton>
                </ActionBottomButtons>
                </ActionsTitle>
                <FlexBox
                    width={'100%'}
                    direction='row'
                    justify='space-between'
                    align='center'
                    offsetBottom={is1440BP ? 24 : 32}
                >
                  {isMobile ? MobileDropdownTabs : <FlexBox gx={24}>
                    {Object.keys(tabNames).map((tabKey, index) => <ProjectTabItem isActive={activeTab == tabKey} key={index} onClick={() => setActiveTab(tabKey)}>
                      {/* @ts-ignore */}
                      {tabNames[tabKey]}
                    </ProjectTabItem>)}
                  </FlexBox>}
                  {isMobile ? (
                    <MobileFilterSort onClick={onMobileSortingClick}>
                      <SortIcon/>
                      {t(`sorting_type.${Number(sorting) === 1 ? 'latest' : 'popular'}`)}
                    </MobileFilterSort>
                  ) : searchBar}
                </FlexBox>
              {activeTab === SEND_PROJECT_TABS.find_projects && (
                <FlexBox width="100%" offsetBottom={24}>
                  <SearchInputComponent
                    searchText={searchInputValue}
                    setSearchText={(value) => {
                      setSearchInputValue(value)
                      debouncedSetSearchText(value)
                    }}
                    placeholder={t('send_projects.search_placeholder')}
                  />
                </FlexBox>
              )}
              {isNoProjects ? <NoProjectWrapper>{t('send_projects.nothing_found')}</NoProjectWrapper> : (
                isSelectedProjectsReorderMode ? (
                  <TeamTabProjectsOrderGrid
                    projects={displayProjects}
                    entityType="projects"
                    selectedProjectIds={selectedProjectIds}
                    onToggleProject={onToggleSelectedProject}
                    onSortEnd={onSelectedProjectSortEnd}
                  />
                ) : (
                  <ProjectsGridNew k={undefined} isLoading={isProjectsLoading}>
                    {projectsGrid}
                  </ProjectsGridNew>
                )
              )}
              {!isNoProjects && !isSelectedProjectsReorderMode && <Pagination
                  //@ts-ignore
                  pages={(isFindProjectsByName ? searchProjectsPage?.paging?.pages : projectsPaging?.pages) ?? 0}
                  page={Number(currentPage)}
                  isLoading={isProjectsLoading}
                  onPageChange={(page: any) => {
                    onPageChange(page)
                    setT(Date.now())
                    scrollTop()
                  }}
                  //@ts-ignore
                  isCanLoadMore={currentPage < ((isFindProjectsByName ? searchProjectsPage?.paging?.pages : projectsPaging?.pages) ?? 0)}
              />}
              {/* {is744BP && (
                <ActionBottomButtons>
                    <BrgButton 
                      width={ isMobile ? 112 : 187}  
                      disabled={selectedProjects?.length > maxProjects} 
                      onClick={onSend}
                      variant={ButtonVariant.Filled}
                    >
                      {`${submitText || t('competition.send')}${selectedProjects?.length > 0 ? ` (${selectedProjects?.length})` : ''}`}
                    </BrgButton>
                </ActionBottomButtons>
              )} */}
            </ActionsWrapper>
        </FlexBox>
    </ModalContainer>
  );
};
import {FlexBox, useToasts, useIsMobile, useBreakpoint, BrgButton, ButtonVariant} from '@brg/ui';
import { MobileFilterSort } from 'shared/pages/explore/styles';
import { SortIcon } from 'shared/icons';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { API, Endpoints, Nullable, PageModel, Project, GetProjectsByFilterProps, TeamAPI } from '@brg/api';
import {LayoutConst, useModal} from '../../../core';
import { TeamTabProjectsOrderGrid } from '../teamTabProjectsOrder/TeamTabProjectsOrderGrid';
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import {
  ActionsTitle,
  ActionsWrapper,
  MainTitle,
  ActionBottomButtons,
  ModalContainer,
  NoProjectWrapper, ProjectTabItem,
  SecondTitle
} from './styles';
import { ProjectsSearchBar } from 'shared/components/projectsSearchBar/projectsSearchBar';
import { SortingTypeIndex } from 'shared/constants/sortingType';
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { AppTester } from 'supporting';
import { ProjectsGridNew } from 'shared/components/grids';
import ProjectCardNew from 'shared/components/projectCard/projectCardNew';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import { ProjectDelegate } from 'project-delegate';
import { RingPositions } from 'shared/constants/ringPositionType';
import {useProjectsList} from "../../hooks/api/useProjectsByFilter";
import {DropdownTabs} from "../../pages/exploreHseContextsNew/components/DropdownTabs";
import {useTranslation} from "react-i18next";
import {useProfile} from "@brg/auth";
import {SearchInputComponent} from "../../components/SearchInput/SearchInputComponent";
import {Pagination} from "../../components/pagination";
import { useParams, useRouteMatch } from 'react-router-dom';
import { LinkTo } from 'shared/constants/linkTo';
import { useDebounceCallback } from 'shared/helpers/useDebounceCallback';

enum SEND_PROJECT_TABS {
  projects = 'projects',
  presentations = 'presentations',
  books = 'books',
  bookmarks = 'bookmarks',
  find_projects = 'find_projects',
  selected_projects = 'selected_projects'
}

const MIN_PROJECT_SEARCH_LENGTH = 2

const appendArrayQuery = (
  req: ReturnType<typeof API.request>,
  key: string,
  values?: (string | number)[] | null,
) => {
  if (!values?.length) {
    return
  }

  values.forEach((value) => req.addQuery(key, value))
}

interface ISendProjectProps {
  alreadyProjects?: string[],
  project: Project,
  onSelectProjects?: (val: string[]) => void,
  maxProjects?: number,
  teamExtraFilter?: any,
  teamContexts?: string[],
  isPresentation?: boolean,
  hideBookmark?: boolean;
  status?: number,
  hideSearch?: boolean;
  contextsNotContains?: string[];
  onlyOnePresentation?: boolean;
  submitText?: string;
  descriptionText?: string;
  externalParams?: Record<string, any>;
  onlyAuthorProjects?: boolean;
  allowSelectedProjectsReorder?: boolean;
}

export const SendProjectLongreadModal: FC<ISendProjectProps> = (props) => {

  const {
    alreadyProjects: alreadyProjectIds,
    onSelectProjects,
    maxProjects = 1,
    teamExtraFilter,
    status = undefined,
    teamContexts,
    onlyOnePresentation = true,
    onlyAuthorProjects,
    contextsNotContains,
    hideBookmark,
    hideSearch,
    externalParams,
    submitText,
    descriptionText,
    project,
    allowSelectedProjectsReorder = false,
  } = props;

  const profile = useProfile()
  const [alreadyTime, setAlreadyTime] = useState(new Date().getTime())
  const [time, setT] = useState(new Date().getTime())
  const { t, i18n: { language } } = useTranslation();
  const isGeo = AppTester.isGeograffee();
  const isLMS = AppTester.isLMSHSE();
  const publishedStatuses = useMemo(() => (isLMS ? [1, 10] : [1]), [isLMS]);
  const [sorting, setSorting] = useState(1)
  const [searchText, setSearchText] = useState('')
  const [searchInputValue, setSearchInputValue] = useState('')
  const debouncedSetSearchText = useDebounceCallback(setSearchText, 350)
  const [activeTab, setActiveTab] = useState<string | SEND_PROJECT_TABS>(SEND_PROJECT_TABS.projects)
  const toasts = useToasts();
  const isMobile = useIsMobile()
  const isS = useBreakpoint(LayoutConst.screen.s - 1)
  const modal = useModal();
  const isProjectEdit = useRouteMatch(LinkTo.projectEdit)?.params as Record<string, string>
  const [filterOpt, setFilterOpt] = useState<GetProjectsByFilterProps | null>(
      null
  )
  const [selectedProjects, setSelectedProjects] = useState<{id: string, isPresentation: boolean}[]>([])
  const [projectsCache, setProjectsCache] = useState<Record<string, Project>>({})
  const [searchProjectsPage, setSearchProjectsPage] = useState<PageModel<Project> | null>(null)
  const [isSearchProjectsLoading, setIsSearchProjectsLoading] = useState(false)
  const [searchAuthorIds, setSearchAuthorIds] = useState<string[] | null>(null)

  const mergeProjectsIntoCache = useCallback((items?: Project[]) => {
    if (!items?.length) {
      return
    }

    setProjectsCache((prev) => {
      const next = { ...prev }
      let changed = false

      items.forEach((item) => {
        const projectId = item?.projectId
        if (!projectId) {
          return
        }

        if (next[projectId]) {
          return
        }

        next[projectId] = item
        changed = true
      })

      return changed ? next : prev
    })
  }, [])

  const currentProjectId = useMemo(() => (isProjectEdit?.id || undefined), [isProjectEdit]);

  const isEditing = (id: string) => {
    return id === currentProjectId
  }

  const [currentPage, setPage] = useState(1)
  const onPageChange = useCallback((page: any): void => {
    setPage(page)
    setFilterOpt(null)
    setT(Date.now())
  }, [])
  const onSend = useCallback(() => {
    const data = selectedProjects?.map((project: any) => project?.id)
    onSelectProjects && onSelectProjects(data)
    modal.hide()
  }, [onSelectProjects, selectedProjects])
  const is1440BP = useBreakpoint(LayoutConst.screen.s)

  const scrollTop = () => window.scrollTo(0, 0);

  const searchedId = useMemo(() => {
    const splittedText = searchText?.split('/');
    const lastPart = splittedText?.length > 0 ? splittedText[splittedText?.length - 1] : '';
    
    const idMatch = lastPart.match(/([a-f0-9]{32})$/i);
    return idMatch ? idMatch[1] : lastPart;
  }, [searchText])
  const isSearchLink = useMemo(() => {
    const splittedText = searchText?.split('/');
    return splittedText?.length > 1;
  }, [searchText])

  const noSelectedProjects = useMemo(
    () => selectedProjects?.length === 0 && activeTab === SEND_PROJECT_TABS.selected_projects,
    [selectedProjects?.length, activeTab],
  )
  const trimmedSearchText = useMemo(() => searchText.trim(), [searchText])

  const isFindProjectsByLink = useMemo(
    () => activeTab === SEND_PROJECT_TABS.find_projects && isSearchLink,
    [activeTab, isSearchLink],
  )

  const isFindProjectsByName = useMemo(
    () => (
      activeTab === SEND_PROJECT_TABS.find_projects
      && !isSearchLink
      && trimmedSearchText.length >= MIN_PROJECT_SEARCH_LENGTH
    ),
    [activeTab, isSearchLink, trimmedSearchText],
  )

  const noFindProjects = useMemo(
    () => activeTab === SEND_PROJECT_TABS.find_projects && !isFindProjectsByLink && trimmedSearchText.length < MIN_PROJECT_SEARCH_LENGTH,
    [activeTab, isFindProjectsByLink, trimmedSearchText],
  )
  const teamIdForSearch = useMemo(
    () => externalParams?.authorIdsFromTeamIds?.[0] as string | undefined,
    [externalParams?.authorIdsFromTeamIds],
  )
  const hasTeamAuthorsScope = useMemo(() => !!teamIdForSearch, [teamIdForSearch])
  const hasResolvedSearchAuthors = useMemo(
    () => !hasTeamAuthorsScope || !!searchAuthorIds,
    [hasTeamAuthorsScope, searchAuthorIds],
  )
  const isSelectedProjectsReorderMode = (
    allowSelectedProjectsReorder && activeTab === SEND_PROJECT_TABS.selected_projects
  )

  const [projects, isProjectsDefaultLoading, , projectsPaging] = useProjectsList(
    filterOpt,
    language,
    time,
    filterOpt === null
    || noSelectedProjects
    || noFindProjects
    || isFindProjectsByName
  )

  const [alreadyProjects, isProjectsAlreadyLoading, , projectsAlreadyPaging] = useProjectsList(
    // @ts-ignore
    {projectIds: alreadyProjectIds || [], isContextIgnored: true, projectStatus: publishedStatuses, onlyBooks: '', ...(allowSelectedProjectsReorder ? { orderByProjectIds: true } : {})},
    language,
    alreadyTime,
    alreadyProjectIds?.length === 0
  )

  useEffect(() => {
    if (allowSelectedProjectsReorder && alreadyProjectIds?.length) {
      setActiveTab(SEND_PROJECT_TABS.selected_projects)
    }
  }, [allowSelectedProjectsReorder, alreadyProjectIds])

  useEffect(() => {
    const loadedProjects = alreadyProjects?.data || []

    if (allowSelectedProjectsReorder && alreadyProjectIds?.length) {
      const projectsById = new Map(
        loadedProjects.map((project: any) => [project?.projectId, project]),
      )

      setSelectedProjects(
        alreadyProjectIds
          .map((id) => projectsById.get(id))
          .filter(Boolean)
          .map((project: any) => ({
            id: project?.projectId,
            isPresentation: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'].includes(project?.projectType),
          })),
      )
      return
    }

    setSelectedProjects(loadedProjects.map((project: any) => ({
      id: project?.projectId,
      isPresentation: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'].includes(project?.projectType)
    })) || [])
  }, [alreadyProjects, allowSelectedProjectsReorder, alreadyProjectIds])

  useEffect(() => {
    mergeProjectsIntoCache(projects?.data as Project[] | undefined)
  }, [mergeProjectsIntoCache, projects?.data])

  useEffect(() => {
    mergeProjectsIntoCache(searchProjectsPage?.data as Project[] | undefined)
  }, [mergeProjectsIntoCache, searchProjectsPage?.data])

  useEffect(() => {
    mergeProjectsIntoCache(alreadyProjects?.data as Project[] | undefined)
  }, [alreadyProjects?.data, mergeProjectsIntoCache])

  const isProjectsLoading = useMemo(
    () => isProjectsAlreadyLoading || (isFindProjectsByName ? isSearchProjectsLoading : isProjectsDefaultLoading),
    [isFindProjectsByName, isProjectsAlreadyLoading, isProjectsDefaultLoading, isSearchProjectsLoading],
  )

  const coauthorsIds = useMemo(() => {
    if (!teamExtraFilter && project) {
      return project?.coAuthorIds
    }
    return []
  } , [project, teamExtraFilter])

  const authorsIds = useMemo(() => {
    if (!teamExtraFilter && project) {
      return [project?.authorId]
    }
    return []
  } , [project, teamExtraFilter])

  useEffect(() => {
    if (!teamIdForSearch) {
      setSearchAuthorIds(null)
      return
    }

    let isCancelled = false

    TeamAPI.Get({ idTeam: teamIdForSearch })
      .then((response) => response.json())
      .then((teamRaw: any) => {
        if (isCancelled) {
          return
        }

        const nextAuthorIds = Array.from(new Set([
          ...(teamRaw?.ownersIDs || []),
          ...(teamRaw?.membersIDs || []),
        ].filter(Boolean)))

        setSearchAuthorIds(nextAuthorIds)
      })
      .catch(() => {
        if (!isCancelled) {
          setSearchAuthorIds([])
        }
      })

    return () => {
      isCancelled = true
    }
  }, [teamIdForSearch])

  useEffect(() => {
    if (profile && profile?.accountId) {
      const hasTeamAuthorsScope = !!externalParams?.authorIdsFromTeamIds?.filter(Boolean)?.length

      const baseFilters: any = {
        projectFilter: sorting,
        page: currentPage,
        limit: 8,
        projectStatus: publishedStatuses,
        isContextIgnored: true,
        onlyBooks: '',
        ...(currentProjectId ? { excludeProjectIds: [currentProjectId]} : {}),
        contextsNotContains: ['lmsproject', 'lmshseproject', ...(contextsNotContains || [])]
      }
      let defaultFilters: any = {
        ...baseFilters,
        onlyBookmarks: activeTab === SEND_PROJECT_TABS.bookmarks,
      }

      const additionalFilter = hasTeamAuthorsScope ? {} : {
        ...(!!onlyAuthorProjects && activeTab !== SEND_PROJECT_TABS.find_projects ? { onlyAuthors: !!onlyAuthorProjects } : {}),
        ...(!!onlyAuthorProjects ? 
          //@ts-ignore
          { authorIds: [...new Set([...(coauthorsIds || []), ...(authorsIds || []) , profile?.accountId ])] } : 
          //@ts-ignore
          {authorOrCoAuthorIds:  [...new Set([...(coauthorsIds || []), ...(authorsIds || []) , profile?.accountId])]}),
      }

      const withoutTeamFilters = activeTab === SEND_PROJECT_TABS.selected_projects || activeTab === SEND_PROJECT_TABS.find_projects || activeTab === SEND_PROJECT_TABS.bookmarks;
      
      if (teamExtraFilter && !withoutTeamFilters) defaultFilters = {...defaultFilters, isContextIgnored: true, ...teamExtraFilter}
      else if ((teamContexts || [])?.length > 0 && !withoutTeamFilters) defaultFilters = {...defaultFilters, contexts: teamContexts, isContextIgnored: false, ...additionalFilter}
      else if (!withoutTeamFilters) defaultFilters = {...defaultFilters, ...additionalFilter }

      if (activeTab === SEND_PROJECT_TABS.bookmarks) defaultFilters = {...defaultFilters, page: currentPage, limit: 8, onlyBookmarks: activeTab === SEND_PROJECT_TABS.bookmarks, selectProjects: true }
      if (activeTab === SEND_PROJECT_TABS.projects) defaultFilters = {
        ...defaultFilters,
        ...additionalFilter,
        excludeProjectTypes: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'],
        onlyBooks: false,
      }
      if (activeTab === SEND_PROJECT_TABS.presentations) defaultFilters = {
        ...defaultFilters,
        ...additionalFilter,
        projectTypes: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'animated'],
        onlyBooks: false,
      }
      if (activeTab === SEND_PROJECT_TABS.books) {
        defaultFilters = {
          ...defaultFilters,
          ...additionalFilter,
          onlyBooks: true,
          bookStatus: publishedStatuses,
          bookSort: sorting,
        }
      }

      if (activeTab === SEND_PROJECT_TABS.selected_projects) {
        defaultFilters = null
      }
      if (isFindProjectsByLink) {
        defaultFilters = {
          projectFilter: sorting,
          page: currentPage,
          limit: 8,
          isContextIgnored: true,
          projectIds: [searchedId],
          onlyBooks: '',
          ...additionalFilter,
        }
      }

      if (activeTab === SEND_PROJECT_TABS.find_projects && !isFindProjectsByLink) {
        defaultFilters = null
      }

      if (externalParams) {
        const { onlyBooks: externalOnlyBooks, ...restExternalParams } = externalParams
        defaultFilters = {
          ...defaultFilters,
          ...restExternalParams,
          ...(activeTab !== SEND_PROJECT_TABS.books
            && externalOnlyBooks != null
            && externalOnlyBooks !== ''
            ? { onlyBooks: externalOnlyBooks }
            : {}),
        }
      }

      defaultFilters = {
        ...defaultFilters,
        projectStatus: publishedStatuses,
        ...(activeTab === SEND_PROJECT_TABS.books ? { bookStatus: publishedStatuses } : {}),
      }

      setFilterOpt((defaultFilters)
      )
    }
  }, [profile, sorting, currentProjectId, contextsNotContains, currentPage, coauthorsIds, isFindProjectsByLink, onlyAuthorProjects, teamContexts, teamExtraFilter, activeTab, searchedId, publishedStatuses, externalParams])

  useEffect(() => {
    setT(Date.now())
  }, [activeTab, filterOpt])

  useEffect(() => {
    if (activeTab === SEND_PROJECT_TABS.find_projects) {
      onPageChange(1)
    }
  }, [searchText, activeTab, onPageChange])

  useEffect(() => {
    if (!isFindProjectsByName) {
      setSearchProjectsPage(null)
      setIsSearchProjectsLoading(false)
      return
    }

    if (!hasResolvedSearchAuthors) {
      setSearchProjectsPage(null)
      setIsSearchProjectsLoading(false)
      return
    }

    const controller = new AbortController()
    setIsSearchProjectsLoading(true)

    const req = API.request()
      .endpoint(Endpoints.geograffee)
      .url('/api/project/AutoCompletePaging')
      .get()
      .addQuery('key', trimmedSearchText)
      .addQuery('page', currentPage)
      .addQuery('limit', 8)
      .addQuery('projectFilter', sorting)

    appendArrayQuery(req, 'projectStatus', publishedStatuses)
    appendArrayQuery(
      req,
      'authorIds',
      hasTeamAuthorsScope ? searchAuthorIds : externalParams?.authorIds,
    )
    appendArrayQuery(req, 'authorOrCoAuthorIds', externalParams?.authorOrCoAuthorIds)
    appendArrayQuery(req, 'contextsNotContains', ['lmsproject', 'lmshseproject', ...(contextsNotContains || [])])

    req.send({ signal: controller.signal })
      .then((response) => response.json())
      .then((json) => {
        if (controller.signal.aborted) {
          return
        }

        setSearchProjectsPage(API.toLang<PageModel<Project>>(json, language))
      })
      .catch((error) => {
        if (controller.signal.aborted || error?.name === 'AbortError') {
          return
        }

        setSearchProjectsPage(null)
      })
      .finally(() => {
        if (!controller.signal.aborted) {
          setIsSearchProjectsLoading(false)
        }
      })

    return () => controller.abort()
  }, [
    isFindProjectsByName,
    trimmedSearchText,
    currentPage,
    sorting,
    language,
    publishedStatuses,
    externalParams,
    hasResolvedSearchAuthors,
    hasTeamAuthorsScope,
    searchAuthorIds,
    contextsNotContains,
  ])

  const onMobileSortingClick = useCallback(() => {
    setSorting(sorting === 1 ? 2 : 1);
    onPageChange(1)
    setT(Date.now())
  }, [sorting, setSorting]);

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s)
    onPageChange(1)
    setT(Date.now())
  }, [])
  const onSelect = useCallback((project: Project | undefined): void => {
    if (project?.projectId) {
      mergeProjectsIntoCache([project])
    }

    // @ts-ignore
    const isPresentation = ['fixed-ratio-large', 't-shape', 'fixed-ratio-small'].includes(project?.projectType);

    if ((isPresentation || selectedProjects?.findIndex(selectedProjects => selectedProjects?.isPresentation) !== -1) && onlyOnePresentation) {
      setSelectedProjects([{id: project?.projectId || '', isPresentation}])
      return;
    }

    // @ts-ignore
    setSelectedProjects((prev: {id: string, isPresentation: boolean}[]) => {

      const includes = prev?.findIndex(selectedProjects => selectedProjects?.id === project?.projectId) !== -1

      if (includes)
        return prev.filter((a) => a?.id !== project?.projectId)
      if (prev?.length > (maxProjects - 1)) {
        toasts.error(t('competition.max_error') + ' ' + maxProjects);
        return prev;
      }
      return [...prev, {id: project?.projectId, isPresentation}]
    })
  }, [mergeProjectsIntoCache, maxProjects, onlyOnePresentation, toasts, t])

  const displayProjects = useMemo(() => {
    if (activeTab === SEND_PROJECT_TABS.selected_projects || isSelectedProjectsReorderMode) {
      return selectedProjects
        .map(({ id }) => projectsCache[id])
        .filter(Boolean) as Project[]
    }

    if (isFindProjectsByName) {
      return (searchProjectsPage?.data || []) as Project[]
    }

    return (projects?.data || []) as Project[]
  }, [activeTab, isFindProjectsByName, isSelectedProjectsReorderMode, projects?.data, projectsCache, searchProjectsPage?.data, selectedProjects])

  const selectedProjectIds = useMemo(
    () => new Set(selectedProjects.map(({ id }) => id)),
    [selectedProjects],
  )

  const onToggleSelectedProject = useCallback((projectId: string) => {
    const project = projectsCache[projectId]
      || displayProjects.find(({ projectId: id }) => id === projectId)
      || projects?.data?.find(({ projectId: id }) => id === projectId)
      || searchProjectsPage?.data?.find(({ projectId: id }) => id === projectId)

    onSelect(project as Project | undefined)
  }, [displayProjects, onSelect, projects?.data, projectsCache, searchProjectsPage?.data])

  const onSelectedProjectSortEnd = useCallback((projectId: string, newIndex: number) => {
    setSelectedProjects((prev) => {
      const oldIndex = prev.findIndex(({ id }) => id === projectId)
      if (oldIndex === -1 || oldIndex === newIndex) {
        return prev
      }

      return arrayMoveImmutable(prev, oldIndex, newIndex)
    })
  }, [])

  const renderProjectCard = useCallback((v: Nullable<Partial<Project<'Local'>>>, index: number) => (
    <ProjectCardNew
      project={v as any}
      isModal={true}
      withoutGoToProject={true}
      onProjectClick={modal ?
        (projectId?: string, e?: any) => {
          e?.stopPropagation();
          e?.preventDefault();
        } : undefined}
      isSelectable={true}
      //@ts-ignore
      isRejected={ProjectDelegate.isRejectedProject(v)}
      key={(v?.projectId || '') + index}
      {...computeProject(v)}
      isSelectRightNeed={isMobile}
      editingProject={isEditing(v?.projectId ?? '')}
      metaAlwaysVisible
      selectRingPosition={RingPositions.right}
      onSelectProject={onSelect}
      //@ts-ignore
      selected={selectedProjects?.findIndex(selectedProject => selectedProject?.id === v?.projectId ?? '') !== -1}
    />
  ), [isEditing, isMobile, modal, onSelect, selectedProjects])

  const projectsGrid = useMemo(
    () => displayProjects.map((v, index) => renderProjectCard(v, index)),
    [displayProjects, renderProjectCard],
  )

  const searchBar = useMemo(
      () => (
          <ProjectsSearchBar
              isLoading={false}
              sorting={sorting}
              hideRightBar={false}
              hideLeftBar
              hideRightButtons
              onSortingChange={onSortingChange}
              isTagPage={false}
              projectCount={projects?.data?.length}
          />
      ),

      [sorting, onSortingChange, projects]
  )

  const tabNames = useMemo(() => {

    const extraTabs = {
      ...(teamExtraFilter && !hideBookmark && {[SEND_PROJECT_TABS.bookmarks]: t('send_projects.bookmarks')}),
      ...(!hideSearch && {[SEND_PROJECT_TABS.find_projects]: t('send_projects.find_projects')}),
    }

    return ({
      [SEND_PROJECT_TABS.projects]: t('send_projects.projects'),
      [SEND_PROJECT_TABS.presentations]: t('send_projects.presentations'),
      [SEND_PROJECT_TABS.books]: t('send_projects.books'),
      ...extraTabs,
      [SEND_PROJECT_TABS.selected_projects]: t('send_projects.selected_projects') + ' ' + selectedProjects?.length || 0
    })

  }, [selectedProjects, teamExtraFilter, hideBookmark, hideSearch, t])

  const MobileDropdownTabs = useMemo(() => {

    return (
        <DropdownTabs
            whiteTheme={false}
            activeTabKey={activeTab}
            items={tabNames}
            onChange={(tab: any) => {
              setActiveTab(tab)
            }}
        />
    )
  }, [activeTab, tabNames])

  const isNoProjects = useMemo(() => {
    if (activeTab === SEND_PROJECT_TABS.selected_projects) {
      return displayProjects.length === 0
    }

    if (isFindProjectsByName) {
      return !isSearchProjectsLoading && (searchProjectsPage?.data?.length === 0 || !searchProjectsPage?.data)
    }

    return (
      (!isProjectsLoading && (projects?.data?.length === 0 || !projects?.data))
      || noFindProjects
    )
  }, [
    activeTab,
    displayProjects.length,
    isFindProjectsByName,
    isProjectsLoading,
    isSearchProjectsLoading,
    noFindProjects,
    projects?.data,
    searchProjectsPage?.data,
  ])
      
  return (
    <ModalContainer style={{ overflow: 'auto', height: '100%'}} justify="flex-start" offsetTop={88} offsetTopMobile={1}>
      
        <FlexBox width={'100%'} directionMobile='column' justify={isMobile ? 'flex-start': 'center'} align={isMobile ? "center" : 'flex-start'} style={{ position: 'relative'}}>
            <ActionsWrapper direction="column" style={{ justifyContent: 'center', position: 'relative' }}>
              <ActionsTitle justify='space-between' justifyMobile='flex-start' direction='row' >
                <FlexBox direction='column'>
                    <MainTitle>
                        {t(`competition.${maxProjects > 1 ? 'select_projects' : 'select_project'}`)}
                    </MainTitle>
                    {descriptionText && (
                      <SecondTitle>{descriptionText}</SecondTitle>
                    )}
                </FlexBox>
                <ActionBottomButtons>
                  <BrgButton
                    variant={ButtonVariant.Filled} 
                    fullWidth
                    disabled={selectedProjects?.length > maxProjects} 
                    onClick={onSend}
                  >
                    {`${submitText || t('competition.send')}${selectedProjects?.length > 0 ? ` (${selectedProjects?.length})` : ''}`}
                  </BrgButton>
                </ActionBottomButtons>
                </ActionsTitle>
                <FlexBox
                    width={'100%'}
                    direction='row'
                    justify='space-between'
                    align='center'
                    offsetBottom={is1440BP ? 24 : 32}
                >
                  {isMobile ? MobileDropdownTabs : <FlexBox gx={24}>
                    {Object.keys(tabNames).map((tabKey, index) => <ProjectTabItem isActive={activeTab == tabKey} key={index} onClick={() => setActiveTab(tabKey)}>
                      {/* @ts-ignore */}
                      {tabNames[tabKey]}
                    </ProjectTabItem>)}
                  </FlexBox>}
                  {isMobile ? (
                    <MobileFilterSort onClick={onMobileSortingClick}>
                      <SortIcon/>
                      {t(`sorting_type.${Number(sorting) === 1 ? 'latest' : 'popular'}`)}
                    </MobileFilterSort>
                  ) : searchBar}
                </FlexBox>
              {activeTab === SEND_PROJECT_TABS.find_projects && (
                <FlexBox width="100%" offsetBottom={24}>
                  <SearchInputComponent
                    searchText={searchInputValue}
                    setSearchText={(value) => {
                      setSearchInputValue(value)
                      debouncedSetSearchText(value)
                    }}
                    placeholder={t('send_projects.search_placeholder')}
                  />
                </FlexBox>
              )}
              {isNoProjects ? <NoProjectWrapper>{t('send_projects.nothing_found')}</NoProjectWrapper> : (
                isSelectedProjectsReorderMode ? (
                  <TeamTabProjectsOrderGrid
                    projects={displayProjects}
                    entityType="projects"
                    selectedProjectIds={selectedProjectIds}
                    onToggleProject={onToggleSelectedProject}
                    onSortEnd={onSelectedProjectSortEnd}
                  />
                ) : (
                  <ProjectsGridNew k={undefined} isLoading={isProjectsLoading}>
                    {projectsGrid}
                  </ProjectsGridNew>
                )
              )}
              {!isNoProjects && !isSelectedProjectsReorderMode && <Pagination
                  //@ts-ignore
                  pages={(isFindProjectsByName ? searchProjectsPage?.paging?.pages : projectsPaging?.pages) ?? 0}
                  page={Number(currentPage)}
                  isLoading={isProjectsLoading}
                  onPageChange={(page: any) => {
                    onPageChange(page)
                    setT(Date.now())
                    scrollTop()
                  }}
                  //@ts-ignore
                  isCanLoadMore={currentPage < ((isFindProjectsByName ? searchProjectsPage?.paging?.pages : projectsPaging?.pages) ?? 0)}
              />}
              {/* {is744BP && (
                <ActionBottomButtons>
                    <BrgButton 
                      width={ isMobile ? 112 : 187}  
                      disabled={selectedProjects?.length > maxProjects} 
                      onClick={onSend}
                      variant={ButtonVariant.Filled}
                    >
                      {`${submitText || t('competition.send')}${selectedProjects?.length > 0 ? ` (${selectedProjects?.length})` : ''}`}
                    </BrgButton>
                </ActionBottomButtons>
              )} */}
            </ActionsWrapper>
        </FlexBox>
    </ModalContainer>
  );
};
